import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleExclamation = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 12.5C2.25 7.11522 6.61522 2.75 12 2.75C17.3848 2.75 21.75 7.11522 21.75 12.5C21.75 17.8848 17.3848 22.25 12 22.25C6.61522 22.25 2.25 17.8848 2.25 12.5Z",
			fill: "#FEFAD2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 12.5C2.25 7.11522 6.61522 2.75 12 2.75C17.3848 2.75 21.75 7.11522 21.75 12.5C21.75 17.8848 17.3848 22.25 12 22.25C6.61522 22.25 2.25 17.8848 2.25 12.5Z",
			stroke: "#E3A008",
			strokeWidth: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9998 5.50584C11.9998 5.50584 10.4289 5.32104 10.6137 7.03059L11.4918 16.1795H11.9998H12.5079L13.3861 7.03059C13.5707 5.32104 11.9998 5.50584 11.9998 5.50584Z",
			fill: "#723B13"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9999 19.5C12.6665 19.5 13.2069 18.9596 13.2069 18.293C13.2069 17.6264 12.6665 17.0861 11.9999 17.0861C11.3333 17.0861 10.793 17.6264 10.793 18.293C10.793 18.9596 11.3333 19.5 11.9999 19.5Z",
			fill: "#723B13"
		})
	]
});
export default SvgCircleExclamation;
